const questions = [
  {
    id: 1,
    title: 'When was Javascript Created ?',
    info:
      'Javascript , not to be confused with java , was created in 10 days in may 1995.',
  },
  {
    id: 2,
    title: 'What JavaScript means?',
    info:
      ` JavaScript is a programming language commonly used in web development. It was originally developed
      by
      Netscape as a means to add dynamic and interactive elements to websites. ... Like server-side
      scripting
      languages, such as PHP and ASP, JavaScript code can be inserted anywhere within the HTML of a
      webpage.`
  },
  {
    id: 3,
    title: 'Who Created Javascript ?',
    info:
      'Brendan Eich.',
  },
  {
    id: 4,
    title: 'How Many Data Type in Javascript?',
    info:
      'there are six data type in javasript Number , String , Object , Function Boolean , Undefined.',
  },
  {
    id: 5,
    title: 'who Created React Js?',
    info:
      'React js Created facebook in 2011 ',
  },
];

export default questions;
